import {Task} from '../models/TaskModels'

export const ROWS_PER_PAGE_LIST = [7, 14, 21, 28, 35, 42, 49, 56, 63, 70]

export const INIT_TASK: Task = {
  officeHour: 0,
  overtimeHour: 0,
  taskOffice: '',
  taskOverTime: '',
  project: {
    id: '',
  },
}
